<div class="ms-3">
    <h4 translate="VIRKESKOP_ANBUD_KONTRAKT_TILLAGDA_FILER"></h4>
    <div class="d-flex">
        @if (fileUploadError.length > 0) {
        <div class="alert alert-danger pa-3" role="alert">
            {{fileUploadError}}
        </div>
        }
    </div>
    <div class="d-flex form-spacing pb-3">
        <div class="col-9 ">
            <rask-file-upload
                accept=".txt,.pdf,.xlsx,.xls,.doc,.docx,.msg,.jpg,.jpeg,.png"
                (fileChange)="onFileSelected(upload.files)"
                [disabled]="!hasUploadFilePermission"
                [multiple]="true"
                #upload
                class="file-input-box">
                <span class="my-auto">
                    @if(kontraktId > 0){
                    {{ fileName ||
                    'VIRKESKOP_ANBUD_KONTRAKT_TILLAGDA_FILER_LAGG_TILL_BILAGA' |
                    translate }}
                    }
                    @else{
                    För att kunna lägga till filer måste kontraktet först sparas
                    }
                </span>
            </rask-file-upload>
        </div>
        <div class="col">
            <button type="button" class="btn btn-primary" [disabled]="uploadButtonInactive"
                (click)="uploadFile()"
                translate="VIRKESKOP_ANBUD_KONTRAKT_TILLAGDA_FILER_LADDA_UP"></button>
        </div>
    </div>
    @if (bilagor?.length > 0) {
    <div
        class="col-10 pb-5">
        <div class="bilagor-row bilagor-header">
            <div class="d-flex col-6">
                <div class="icon-column"></div>
                <div class="filename-column">
                    Filnamn
                </div>
            </div>
            @if (hasEditFilePermission && !isSkogsvard) {
            <div
                class="col-6">
                Åtkomst till fil
            </div>
            }
        </div>
        @for (dokument of bilagor; track dokument) {
        <div class="bilagor-row">
            <div class="d-flex col-6">
                <div class="icon-column">
                    <i class="far fa-file"></i>
                </div>
                <div class="filename-column">
                    @if (hasViewFilePermission) {
                        <div>
                            <a href="javascript:void(0)" [title]="dokument.fileName" (click)="openDokument(dokument)"
                                class="fw-bold filename">{{dokument.fileName}}</a>
                            <a href="javascript:void(0)" (click)="downloadDokument(dokument)"
                                class="btn btn-lg btn-icon" title="Ladda ner dokumentet">
                                <span class="fas fa-download fa-xs"></span>
                            </a>
                        </div>
                    } @else {
                        <div class="filename file-locked">{{dokument.fileName}}</div>
                    }
                    <div>Version {{ dokument.fileVersion }} | {{ dokument.fileDate | date: 'yyyy-MM-dd HH:mm:ss' }}</div>
                </div>
            </div>
            @if (hasEditFilePermission) {
            <div
                class="d-flex col-6">
                @if(!isSkogsvard) {
                <rask-checkbox
                    text="Synlig för köpplanerare"
                    [flexResize]="true"
                    [(ngModel)]="dokument.synligForKopplanera"
                    (ngModelChange)="synligForKopplaneraChange(dokument, $event)">
                </rask-checkbox>
                }
                <rask-button
                    [disabled]="fileActionInProgress || !hasEditFilePermission"
                    type="button"
                    class="remove-button ms-auto"
                    icon="far fa-trash-alt" color="tertiary"
                    (click)="deleteBilaga(dokument)" negative>
                    Ta bort fil
                </rask-button>
            </div>
            }
        </div>
        }
    </div>
    }
</div>